import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({ name: 'daysUntil' })
export class DaysUntilPipe implements PipeTransform {
  transform(date: string): number {
    return differenceInDays(new Date(date), new Date());
  }
}
